// import { ViewLeadsWithAppointmentMissed } from './ViewLeadsWithAppointmentMissed'
// import { ViewLeadWithAppointmentScheduled } from './ViewLeadWithAppointmentScheduled'
import { MapStageModal } from '@forwardflow/modals'
// import { ViewNurturing } from './ViewNurturing'
// import { ViewStop } from './ViewStop'
import { Button } from '@forwardflow/ui-v2'
import { useMapStageStore } from '@forwardflow/store/modal'

const StageMapping = () => {
   const { openMapStageModal } = useMapStageStore()
   return (
      <div className="flex flex-col flex-1">
         <div className="flex items-center justify-between pt-6 pb-10 pl-10 pr-4 gap-y-4">
            <p className="text-[22px] font-medium">Stage mapping</p>
            <Button
               className="!h-10 !rounded !mt-0 flex items-center gap-4"
               onClick={() => {
                  openMapStageModal(true)
               }}
            >
               Revisit stage mapping
            </Button>
         </div>

         <div className="flex flex-col pb-10 pr-5 gap-y-6">
            {/* <ViewLeadWithAppointmentScheduled />
            <ViewLeadsWithAppointmentMissed />
            <ViewNurturing />
            <ViewStop /> */}
         </div>
         <MapStageModal />
      </div>
   )
}

export default StageMapping
